/**
 * Plain module-level registry for Apollo query variables.
 * Each key maps to a deduplicated array of variables objects.
 */
const queryRegistry = {};

export const queryTracker = {
  add: (array = []) => {
    array.forEach(function (element) {
      const { key, variables = {} } = element || {};
      if (!key) return;
      const itemKey = JSON.stringify(variables);
      if (!queryRegistry[key]) queryRegistry[key] = new Map();
      queryRegistry[key].set(itemKey, variables);
    });
  },
  get: (key) => {
    if (!queryRegistry[key]) return [];
    return Array.from(queryRegistry[key].values());
  },
};

/**
 * @deprecated Use queryTracker.get(key) directly instead.
 * Kept for backwards compatibility with _query-tracker.js hook.
 */
export const queryAtoms = new Proxy(
  {},
  {
    get: (_, key) => queryTracker.get(String(key)),
  },
);
